var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from '@mui/material';
import { FaRegQuestionCircle } from 'react-icons/fa';
import { CustomBestBuyLogo } from './custom-best-buy-logo';
export function DinTestSidePanel() {
    return (_jsxs("div", __assign({ className: "flex flex-col items-center justify-between h-full bg-primary p-10" }, { children: [_jsxs("div", __assign({ className: "flex flex-col text-left gap-5" }, { children: [_jsx(FaRegQuestionCircle, { color: "white" }), _jsxs(Typography, __assign({ className: "text-white text-left m-0 text-lg" }, { children: ["We will play ", _jsx("strong", { children: "3 numbers" }), " with background noise."] })), _jsxs(Typography, __assign({ className: "text-white text-left m-0 text-lg" }, { children: ["Enter the numbers you hear in the order you hear them and press", ' ', _jsx("strong", { children: "OK." })] })), _jsxs(Typography, __assign({ className: "text-white text-left m-0 text-lg" }, { children: ["If you can't hear the numbers clearly, enter your", ' ', _jsx("strong", { children: "best guess." })] }))] })), _jsx(CustomBestBuyLogo, { imageHeight: 40, imageWidth: 70, className: "text-white" })] })));
}
